var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-bottom-sheet',{ref:"sheet",attrs:{"value":_vm.isDisplay,"persistent":_vm.isPersistent},on:{"input":_vm.onClose}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }